import React from 'react';
import Img from 'react-image';
import { Placeholder } from './PlaceholderImage';

const styles = {
  display: 'block',
  maxWidth: '100%',
  width: '100%',
  height: '100%',
  maxHeight: '100%',
  objectFit: 'cover'
};

export function Image({ type, src, orientationType, ...rest }) {
  return (
    <Img
      loader={<Placeholder type={type} orientationType={orientationType} />}
      unloader={<Placeholder type={type} orientationType={orientationType} />}
      style={styles}
      src={src}
      {...rest}
    />
  );
}

Image.displayName = 'Image';
